'use strict';
/* global BigInt */
/**
 * bcrypt_pbkdf (la derivacion de claves de OpenSSH para claves privadas cifradas, formato openssh-key-v1) en JavaScript
 * puro y sincrono, sin dependencias: Blowfish + SHA-512. Se usa para cifrar la clave privada al exportarla con
 * passphrase (panel) y para comprobar la passphrase de una clave cifrada al importarla (servidor).
 *
 * ESTE FICHERO EXISTE DOS VECES, identico: server/services/bcryptPbkdf.js y client/src/utils/bcryptPbkdf.js (el panel no
 * puede importar fuera de src/ y el servidor no depende del panel). Se mantienen iguales; server/services/sshKeys.test.js
 * lo comprueba. La app Flutter tiene su propio port en mobile/lib/core/ssh/.
 *
 * Constantes: Blowfish usa los digitos hexadecimales de pi (P: 18 palabras, S: 4x256). Estan generadas con un calculo
 * de pi y comparadas palabra por palabra con las de bcryptjs; SHA-512 calcula sus constantes con raices enteras
 * (las 80 del cubo y las 8 del cuadrado de los primeros primos) en vez de llevar la tabla.
 */

const BLOWFISH_HEX =
  '243f6a8885a308d313198a2e03707344a4093822299f31d0082efa98ec4e6c89452821e638d01377be5466cf34e90c6c' +
  'c0ac29b7c97c50dd3f84d5b5b54709179216d5d98979fb1bd1310ba698dfb5ac2ffd72dbd01adfb7b8e1afed6a267e96' +
  'ba7c9045f12c7f9924a19947b3916cf70801f2e2858efc16636920d871574e69a458fea3f4933d7e0d95748f728eb658' +
  '718bcd5882154aee7b54a41dc25a59b59c30d5392af26013c5d1b023286085f0ca417918b8db38ef8e79dcb0603a180e' +
  '6c9e0e8bb01e8a3ed71577c1bd314b2778af2fda55605c60e65525f3aa55ab945748986263e8144055ca396a2aab10b6' +
  'b4cc5c341141e8cea15486af7c72e993b3ee1411636fbc2a2ba9c55d741831f6ce5c3e169b87931eafd6ba336c24cf5c' +
  '7a325381289586773b8f48986b4bb9afc4bfe81b6628219361d809ccfb21a991487cac605dec8032ef845d5de98575b1' +
  'dc262302eb651b8823893e81d396acc50f6d6ff383f442392e0b4482a484200469c8f04a9e1f9b5e21c66842f6e96c9a' +
  '670c9c61abd388f06a51a0d2d8542f68960fa728ab5133a36eef0b6c137a3be4ba3bf0507efb2a98a1f1651d39af0176' +
  '66ca593e82430e888cee8619456f9fb47d84a5c33b8b5ebee06f75d885c12073401a449f56c16aa64ed3aa62363f7706' +
  '1bfedf72429b023d37d0d724d00a1248db0fead349f1c09b075372c980991b7b25d479d8f6e8def7e3fe501ab6794c3b' +
  '976ce0bd04c006bac1a94fb6409f60c45e5c9ec2196a246368fb6faf3e6c53b51339b2eb3b52ec6f6dfc511f9b30952c' +
  'cc814544af5ebd09bee3d004de334afd660f2807192e4bb3c0cba85745c8740fd20b5f39b9d3fbdb5579c0bd1a60320a' +
  'd6a100c6402c7279679f25fefb1fa3cc8ea5e9f8db3222f83c7516dffd616b152f501ec8ad0552ab323db5fafd238760' +
  '53317b483e00df829e5c57bbca6f8ca01a87562edf1769dbd542a8f6287effc3ac6732c68c4f5573695b27b0bbca58c8' +
  'e1ffa35db8f011a010fa3d98fd2183b84afcb56c2dd1d35b9a53e479b6f84565d28e49bc4bfb9790e1ddf2daa4cb7e33' +
  '62fb1341cee4c6e8ef20cada36774c01d07e9efe2bf11fb495dbda4dae909198eaad8e716b93d5a0d08ed1d0afc725e0' +
  '8e3c5b2f8e7594b78ff6e2fbf2122b648888b812900df01c4fad5ea0688fc31cd1cff191b3a8c1ad2f2f2218be0e1777' +
  'ea752dfe8b021fa1e5a0cc0fb56f74e818acf3d6ce89e299b4a84fe0fd13e0b77cc43b81d2ada8d9165fa26680957705' +
  '93cc7314211a1477e6ad206577b5fa86c75442f5fb9d35cfebcdaf0c7b3e89a0d6411bd3ae1e7e4900250e2d2071b35e' +
  '226800bb57b8e0af2464369bf009b91e5563911d59dfa6aa78c14389d95a537f207d5ba202e5b9c5832603766295cfa9' +
  '11c819684e734a41b3472dca7b14a94a1b5100529a532915d60f573fbc9bc6e42b60a47681e6740008ba6fb5571be91f' +
  'f296ec6b2a0dd915b6636521e7b9f9b6ff34052ec585566453b02d5da99f8fa108ba47996e85076a4b7a70e9b5b32944' +
  'db75092ec4192623ad6ea6b049a7df7d9cee60b88fedb266ecaa8c71699a17ff5664526cc2b19ee1193602a575094c29' +
  'a0591340e4183a3e3f54989a5b429d656b8fe4d699f73fd6a1d29c07efe830f54d2d38e6f0255dc14cdd20868470eb26' +
  '6382e9c6021ecc5e09686b3f3ebaefc93c9718146b6a70a1687f358452a0e286b79c5305aa5007373e07841c7fdeae5c' +
  '8e7d44ec5716f2b8b03ada37f0500c0df01c1f040200b3ffae0cf51a3cb574b225837a58dc0921bdd19113f97ca92ff6' +
  '9432477322f547013ae5e58137c2dadcc8b576349af3dda7a94461460fd0030eecc8c73ea4751e41e238cd993bea0e2f' +
  '3280bba1183eb3314e548b384f6db9086f420d03f60a04bf2cb8129024977c795679b072bcaf89afde9a771fd9930810' +
  'b38bae12dccf3f2e5512721f2e6b7124501adde69f84cd877a5847187408da17bc9f9abce94b7d8cec7aec3adb851dfa' +
  '63094366c464c3d2ef1c18473215d908dd433b3724c2ba1612a14d432a65c45150940002133ae4dd71dff89e10314e55' +
  '81ac77d65f11199b043556f1d7a3c76b3c11183b5924a509f28fe6ed97f1fbfa9ebabf2c1e153c6e86e34570eae96fb1' +
  '860e5e0a5a3e2ab3771fe71c4e3d06fa2965dcb999e71d0f803e89d65266c8252e4cc9789c10b36ac6150eba94e2ea78' +
  'a5fc3c531e0a2df4f2f74ea7361d2b3d1939260f19c279605223a708f71312b6ebadfe6eeac31f66e3bc4595a67bc883' +
  'b17f37d1018cff28c332ddefbe6c5aa56558218568ab9802eecea50fdb2f953b2aef7dad5b6e2f841521b62829076170' +
  'ecdd4775619f151013cca830eb61bd960334fe1eaa0363cfb5735c904c70a239d59e9e0bcbaade14eecc86bc60622ca7' +
  '9cab5cabb2f3846e648b1eaf19bdf0caa02369b9655abb5040685a323c2ab4b3319ee9d5c021b8f79b540b19875fa099' +
  '95f7997e623d7da8f837889a97e32d7711ed935f166812810e358829c7e61fd696dedfa17858ba9957f584a51b227263' +
  '9b83c3ff1ac24696cdb30aeb532e30548fd948e46dbc312858ebf2ef34c6ffeafe28ed61ee7c3c735d4a14d9e864b7e3' +
  '42105d14203e13e045eee2b6a3aaabeadb6c4f15facb4fd0c742f442ef6abbb5654f3b1d41cd2105d81e799e86854dc7' +
  'e44b476a3d816250cf62a1f25b8d2646fc8883a0c1c7b6a37f1524c369cb749247848a0b5692b285095bbf00ad19489d' +
  '1462b17423820e0058428d2a0c55f5ea1dadf43e233f70613372f0928d937e41d65fecf16c223bdb7cde3759cbee7460' +
  '4085f2a7ce77326ea607808419f8509ee8efd85561d99735a969a7aac50c06c25a04abfc800bcadc9e447a2ec3453484' +
  'fdd567050e1e9ec9db73dbd3105588cd675fda79e3674340c5c43465713e38d83d28f89ef16dff20153e21e78fb03d4a' +
  'e6e39f2bdb83adf7e93d5a68948140f7f64c261c94692934411520f77602d4f7bcf46b2ed4a20068d40824713320f46a' +
  '43b7d4b7500061af1e39f62e9724454614214f74bf8b88404d95fc1d96b591af70f4ddd366a02f45bfbc09ec03bd9785' +
  '7fac6dd031cb850496eb27b355fd3941da2547e6abca0a9a28507825530429f40a2c86dae9b66dfb68dc1462d7486900' +
  '680ec0a427a18dee4f3ffea2e887ad8cb58ce0067af4d6b6aace1e7cd3375fecce78a399406b2a4220fe9e35d9f385b9' +
  'ee39d7ab3b124e8b1dc9faf74b6d185626a36631eae397b23a6efa74dd5b43326841e7f7ca7820fbfb0af54ed8feb397' +
  '454056acba48952755533a3a20838d87fe6ba9b7d096954b55a867bca1159a58cca9296399e1db33a62a4a563f3125f9' +
  '5ef47e1c9029317cfdf8e80204272f7080bb155c05282ce395c11548e4c66d2248c1133fc70f86dc07f9c9ee41041f0f' +
  '404779a45d886e17325f51ebd59bc0d1f2bcc18f41113564257b7834602a9c60dff8e8a31f636c1b0e12b4c202e1329e' +
  'af664fd1cad181156b2395e0333e92e13b240b62eebeb92285b2a20ee6ba0d99de720c8c2da2f728d012784595b794fd' +
  '647d0862e7ccf5f05449a36f877d48fac39dfd27f33e8d1e0a476341992eff743a6f6eabf4f8fd37a812dc60a1ebddf8' +
  '991be14cdb6e6b0dc67b55106d672c372765d43bdcd0e804f1290dc7cc00ffa3b5390f92690fed0b667b9ffbcedb7d9c' +
  'a091cf0bd9155ea3bb132f88515bad247b9479bf763bd6eb37392eb3cc1159798026e297f42e312d6842ada7c66a2b3b' +
  '12754ccc782ef11c6a124237b79251e706a1bbe64bfb63501a6b101811caedfa3d25bdd8e2e1c3c9444216590a121386' +
  'd90cec6ed5abea2a64af674eda86a85fbebfe98864e4c3fe9dbc8057f0f7c08660787bf86003604dd1fd8346f6381fb0' +
  '7745ae04d736fccc83426b33f01eab71b08041873c005e5f77a057bebde8ae2455464299bf582e614e58f48ff2ddfda2' +
  'f474ef388789bdc25366f9c3c8b38e74b475f25546fcd9b97aeb26618b1ddf84846a0e79915f95e2466e598e20b45770' +
  '8cd55591c902de4cb90bace1bb8205d011a862487574a99eb77f19b6e0a9dc09662d09a1c4324633e85a1f0209f0be8c' +
  '4a99a0251d6efe101ab93d1d0ba5a4dfa186f20f2868f169dcb7da83573906fea1e2ce9b4fcd7f5250115e01a70683fa' +
  'a002b5c40de6d0279af88c27773f8641c3604c0661a806b5f0177a28c0f586e0006058aa30dc7d6211e69ed72338ea63' +
  '53c2dd94c2c21634bbcbee5690bcb6deebfc7da1ce591d766f05e4094b7c018839720a3d7c927c2486e3725f724d9db9' +
  '1ac15bb4d39eb8fced54557808fca5b5d83d7cd34dad0fc41e50ef5eb161e6f8a28514d96c51133c6fd5c7e756e14ec4' +
  '362abfceddc6c837d79a323492638212670efa8e406000e03a39ce37d3faf5cfabc277375ac52d1b5cb0679e4fa33742' +
  'd382274099bc9bbed5118e9dbf0f7315d62d1c7ec700c47bb78c1b6b21a19045b26eb1be6a366eb45748ab2fbc946e79' +
  'c6a376d26549c2c8530ff8ee468dde7dd5730a1d4cd04dc62939bbdba9ba4650ac9526e8be5ee304a1fad5f06a2d519a' +
  '63ef8ce29a86ee22c089c2b843242ef6a51e03aa9cf2d0a483c061ba9be96a4d8fe51550ba645bd62826a2f9a73a3ae1' +
  '4ba99586ef5562e9c72fefd3f752f7da3f046f6977fa0a5980e4a91587b086019b09e6ad3b3ee593e990fd5a9e34d797' +
  '2cf0b7d9022b8b5196d5ac3a017da67dd1cf3ed67c7d2d281f9f25cfadf2b89b5ad6b4725a88f54ce029ac71e019a5e6' +
  '47b0acfded93fa9be8d3c48d283b57ccf8d5662979132e28785f0191ed756055f7960e44e3d35e8c15056dd488f46dba' +
  '03a161250564f0bdc3eb9e153c9057a297271aeca93a072a1b3f6d9b1e6321f5f59c66fb26dcf3197533d928b155fdf5' +
  '035634828aba3cbb28517711c20ad9f8abcc5167ccad925f4de817513830dc8e379d58629320f991ea7a90c2fb3e7bce' +
  '5121ce64774fbe32a8b6e37ec3293d4648de53696413e680a2ae0810dd6db22469852dfd09072166b39a460a6445c0dd' +
  '586cdecf1c20c8ae5bbef7dd1b588d40ccd2017f6bb4e3bbdda26a7e3a59ff453e350a44bcb4cdd572eacea8fa6484bb' +
  '8d6612aebf3c6f47d29be463542f5d9eaec2771bf64e6370740e0d8de75b1357f8721671af537d5d4040cb084eb4e2cc' +
  '34d2466a0115af84e1b0042895983a1d06b89fb4ce6ea0486f3f3b823520ab82011a1d4b277227f8611560b1e7933fdc' +
  'bb3a792b344525bda08839e151ce794b2f32c9b7a01fbac9e01cc87ebcc7d1f6cf0111c3a1e8aac71a908749d44fbd9a' +
  'd0dadecbd50ada380339c32ac69136678df9317ce0b12b4ff79e59b743f5bb3af2d519ff27d9459cbf97222c15e6fc2a' +
  '0f91fc719b941525fae59361ceb69cebc2a8645912baa8d1b6c1075ee3056a0c10d25065cb03a442e0ec6e0e1698db3b' +
  '4c98a0be3278e9649f1f9532e0d392dfd3a0342b8971f21e1b0a74414ba3348cc5be7120c37632d8df359f8d9b992f2e' +
  'e60b6f470fe3f11de54cda541edad891ce6279cfcd3e7e6f1618b166fd2c1d05848fd2c5f6fb2299f523f357a6327623' +
  '93a8353156cccd02acf081625a75ebb56e16369788d273ccde96629281b949d04c50901b71c65614e6c6c7bd327a140a' +
  '45e1d006c3f27b9ac9aa53fd62a80f00bb25bfe235bdd2f671126905b2040222b6cbcf7ccd769c2b53113ec01640e3d3' +
  '38abbd602547adf0ba38209cf746ce7677afa1c52075606085cbfe4e8ae88dd87aaaf9b04cf9aa7e1948c25c02fb8a8c' +
  '01c36ae4d6ebe1f990d4f869a65cdea03f09252dc208e69fb74e6132ce77e25b578fdfe33ac372e6';

const MASK64 = (1n << 64n) - 1n;

function iroot(x, k) {
  if (x < 2n) return x;
  const K = BigInt(k);
  let r = 1n << BigInt(Math.ceil(x.toString(2).length / k) + 1);
  for (;;) {
    const next = ((K - 1n) * r + x / (r ** (K - 1n))) / K;
    if (next >= r) return r;
    r = next;
  }
}
const frac64 = (n, k) => iroot(BigInt(n) << BigInt(64 * k), k) & MASK64;

const PRIMES = [];
for (let n = 2; PRIMES.length < 80; n++) if (PRIMES.every((p) => n % p)) PRIMES.push(n);
const SHA_K = PRIMES.map((p) => frac64(p, 3));
const SHA_H0 = PRIMES.slice(0, 8).map((p) => frac64(p, 2));

const rotr = (x, n) => ((x >> n) | (x << (64n - n))) & MASK64;

/** SHA-512 de un Uint8Array. */
function sha512(msg) {
  const len = msg.length;
  const total = ((len + 17 + 127) >> 7) << 7;
  const buf = new Uint8Array(total);
  buf.set(msg);
  buf[len] = 0x80;
  const bits = BigInt(len) * 8n;
  for (let i = 0; i < 8; i++) buf[total - 1 - i] = Number((bits >> BigInt(8 * i)) & 0xffn);

  const H = SHA_H0.slice();
  const W = new Array(80);
  for (let off = 0; off < total; off += 128) {
    for (let t = 0; t < 16; t++) {
      let w = 0n;
      for (let b = 0; b < 8; b++) w = (w << 8n) | BigInt(buf[off + t * 8 + b]);
      W[t] = w;
    }
    for (let t = 16; t < 80; t++) {
      const s0 = rotr(W[t - 15], 1n) ^ rotr(W[t - 15], 8n) ^ (W[t - 15] >> 7n);
      const s1 = rotr(W[t - 2], 19n) ^ rotr(W[t - 2], 61n) ^ (W[t - 2] >> 6n);
      W[t] = (W[t - 16] + s0 + W[t - 7] + s1) & MASK64;
    }
    let [a, b, c, d, e, f, g, h] = H;
    for (let t = 0; t < 80; t++) {
      const S1 = rotr(e, 14n) ^ rotr(e, 18n) ^ rotr(e, 41n);
      const ch = (e & f) ^ (~e & MASK64 & g);
      const t1 = (h + S1 + ch + SHA_K[t] + W[t]) & MASK64;
      const S0 = rotr(a, 28n) ^ rotr(a, 34n) ^ rotr(a, 39n);
      const maj = (a & b) ^ (a & c) ^ (b & c);
      const t2 = (S0 + maj) & MASK64;
      h = g; g = f; f = e; e = (d + t1) & MASK64; d = c; c = b; b = a; a = (t1 + t2) & MASK64;
    }
    [a, b, c, d, e, f, g, h].forEach((v, i) => { H[i] = (H[i] + v) & MASK64; });
  }
  const out = new Uint8Array(64);
  H.forEach((v, i) => { for (let b = 0; b < 8; b++) out[i * 8 + b] = Number((v >> BigInt(56 - 8 * b)) & 0xffn); });
  return out;
}

// --- Blowfish -------------------------------------------------------------------------------------------------------

const INIT = new Uint32Array(1042);
for (let i = 0; i < 1042; i++) INIT[i] = parseInt(BLOWFISH_HEX.slice(i * 8, i * 8 + 8), 16) >>> 0;

function newState() {
  return { P: INIT.slice(0, 18), S: INIT.slice(18), l: 0, r: 0 };
}

/** Cifra un bloque (st.l, st.r) en su sitio. */
function encipher(st) {
  const { P, S } = st;
  let l = st.l ^ P[0];
  let r = st.r;
  for (let i = 1; i <= 16; i += 2) {
    r ^= ((((S[l >>> 24] + S[256 + ((l >>> 16) & 255)]) ^ S[512 + ((l >>> 8) & 255)]) + S[768 + (l & 255)]) >>> 0) ^ P[i];
    l ^= ((((S[r >>> 24] + S[256 + ((r >>> 16) & 255)]) ^ S[512 + ((r >>> 8) & 255)]) + S[768 + (r & 255)]) >>> 0) ^ P[i + 1];
  }
  st.l = (r ^ P[17]) >>> 0;
  st.r = l >>> 0;
}

/** Siguiente palabra de 32 bits de "data", dando la vuelta al llegar al final. cur es { j }. */
function stream2word(data, cur) {
  let w = 0;
  for (let i = 0; i < 4; i++) {
    if (cur.j >= data.length) cur.j = 0;
    w = ((w << 8) | data[cur.j]) >>> 0;
    cur.j++;
  }
  return w;
}

function xorKey(st, key) {
  const cur = { j: 0 };
  for (let i = 0; i < 18; i++) st.P[i] = (st.P[i] ^ stream2word(key, cur)) >>> 0;
}

function fillState(st, data) { // data null = expand0state (sin mezclar datos)
  const cur = { j: 0 };
  st.l = 0; st.r = 0;
  for (let i = 0; i < 18; i += 2) {
    if (data) { st.l = (st.l ^ stream2word(data, cur)) >>> 0; st.r = (st.r ^ stream2word(data, cur)) >>> 0; }
    encipher(st);
    st.P[i] = st.l; st.P[i + 1] = st.r;
  }
  for (let i = 0; i < 4; i++) {
    for (let k = 0; k < 256; k += 2) {
      if (data) { st.l = (st.l ^ stream2word(data, cur)) >>> 0; st.r = (st.r ^ stream2word(data, cur)) >>> 0; }
      encipher(st);
      st.S[i * 256 + k] = st.l; st.S[i * 256 + k + 1] = st.r;
    }
  }
}

const MAGIC = Uint8Array.from('OxychromaticBlowfishSwatDynamite', (c) => c.charCodeAt(0));

function bcryptHash(sha2pass, sha2salt) {
  const st = newState();
  xorKey(st, sha2pass);
  fillState(st, sha2salt); // expandstate(data = salt, key = pass)
  for (let i = 0; i < 64; i++) {
    xorKey(st, sha2salt); fillState(st, null);
    xorKey(st, sha2pass); fillState(st, null);
  }
  const cdata = new Uint32Array(8);
  const cur = { j: 0 };
  for (let i = 0; i < 8; i++) cdata[i] = stream2word(MAGIC, cur);
  for (let n = 0; n < 64; n++) {
    for (let i = 0; i < 8; i += 2) {
      st.l = cdata[i]; st.r = cdata[i + 1];
      encipher(st);
      cdata[i] = st.l; cdata[i + 1] = st.r;
    }
  }
  const out = new Uint8Array(32);
  for (let i = 0; i < 8; i++) {
    out[4 * i + 3] = (cdata[i] >>> 24) & 255;
    out[4 * i + 2] = (cdata[i] >>> 16) & 255;
    out[4 * i + 1] = (cdata[i] >>> 8) & 255;
    out[4 * i] = cdata[i] & 255;
  }
  return out;
}

/**
 * bcrypt_pbkdf de OpenBSD. password y salt: Uint8Array. Devuelve keyLen bytes.
 */
function bcryptPbkdf(password, salt, keyLen, rounds) {
  if (!(rounds >= 1) || !password.length || !salt.length || !(keyLen >= 1) || keyLen > 1024) throw new Error('bcrypt_pbkdf: bad parameters');
  const key = new Uint8Array(keyLen);
  const stride = Math.floor((keyLen + 31) / 32);
  let amt = Math.floor((keyLen + stride - 1) / stride);
  const sha2pass = sha512(password);
  const countsalt = new Uint8Array(salt.length + 4);
  countsalt.set(salt);
  let remaining = keyLen;
  for (let count = 1; remaining > 0; count++) {
    countsalt[salt.length] = (count >>> 24) & 255;
    countsalt[salt.length + 1] = (count >>> 16) & 255;
    countsalt[salt.length + 2] = (count >>> 8) & 255;
    countsalt[salt.length + 3] = count & 255;
    let tmp = bcryptHash(sha2pass, sha512(countsalt));
    const out = tmp.slice();
    for (let i = 1; i < rounds; i++) {
      tmp = bcryptHash(sha2pass, sha512(tmp));
      for (let j = 0; j < 32; j++) out[j] ^= tmp[j];
    }
    amt = Math.min(amt, remaining);
    let i = 0;
    for (; i < amt; i++) {
      const dest = i * stride + (count - 1);
      if (dest >= keyLen) break;
      key[dest] = out[i];
    }
    remaining -= i;
  }
  return key;
}

module.exports = { bcryptPbkdf, sha512 };
